var _excluded = ["url", "uuid", "uid"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file 收集页面的 fmp
 * @author <caierwei@baijia.com>
 * @module module/fmp
 */
import request from './util/request';
import configurable from './util/configurable';
import performance from './util/performance';
import onRouteChange from './util/onRouteChange';
import { trackID, getUserID, Config, HB_SESSION_ID_KEY } from './util/config';
import { camelToUnder, parse } from './util/json';
import cookie from './util/cookie';
import { on, off } from './util/dom';
import getPath from './util/getPath';
var win = typeof window !== 'undefined' && window;
var doc = win && document;
var rAF = win.requestAnimationFrame || function raf(callback) {
  win.setTimeout(callback, 1000 / 60);
};
var cAF = win.cancelAnimationFrame || function caf(id) {
  win.clearTimeout(id);
};
var timing = performance.timing;

// 当前浏览器支持的 hidden 和 visibilityChange 写法
var _ref = [['hidden', 'visibilitychange'], ['webkitHidden', 'webkitvisibilitychange'], ['mozHidden', 'mozvisibilitychange'], ['msHidden', 'msvisibilitychange']].filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return key in (doc || {});
  })[0] || [],
  _ref2 = _slicedToArray(_ref, 2),
  hidden = _ref2[0],
  visibilityChange = _ref2[1];

/**
 * 收集标记的有意义的元素
 *
 * @const {string}
 */
var LOG_FLAG_N_FMP_HERO = 'data-habo-fmp-hero';

/**
 * 收集标记的有意义的元素的属性名
 *
 * @const {string}
 */
var LOG_FLAG_N_FMP_PARAMS = 'data-habo-fmp-params';
var HB_SESSION_ID_VALUE = cookie.get(HB_SESSION_ID_KEY);

/**
 * 性能上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
var report = configurable(function (json, callback) {
  var _objectSpread2;
  var _camelToUnder = camelToUnder(json),
    _camelToUnder$url = _camelToUnder.url,
    url = _camelToUnder$url === void 0 ? location.href : _camelToUnder$url,
    _camelToUnder$uuid = _camelToUnder.uuid,
    uuid = _camelToUnder$uuid === void 0 ? trackID : _camelToUnder$uuid,
    _camelToUnder$uid = _camelToUnder.uid,
    uid = _camelToUnder$uid === void 0 ? getUserID() : _camelToUnder$uid,
    rest = _objectWithoutProperties(_camelToUnder, _excluded);
  var _ref5 = typeof navigator !== 'undefined' && navigator.connection || {},
    _ref5$type = _ref5.type,
    nt = _ref5$type === void 0 ? 'unknown' : _ref5$type,
    _ref5$effectiveType = _ref5.effectiveType,
    net = _ref5$effectiveType === void 0 ? '' : _ref5$effectiveType,
    _ref5$rtt = _ref5.rtt,
    nrtt = _ref5$rtt === void 0 ? 0 : _ref5$rtt,
    _ref5$downlinkMax = _ref5.downlinkMax,
    ndlm = _ref5$downlinkMax === void 0 ? 0 : _ref5$downlinkMax,
    _ref5$downlink = _ref5.downlink,
    ndl = _ref5$downlink === void 0 ? 0 : _ref5$downlink;

  // 要上报的数据
  var perfData = _objectSpread((_objectSpread2 = {
    // 当前页面 URL
    url: url,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: uuid,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: uid,
    path: getPath(),
    // 页面路径归类
    action_name: getPath(),
    app_nid: Config.APPNID || Config.appNid || Config.appId
  }, _defineProperty(_objectSpread2, HB_SESSION_ID_KEY, HB_SESSION_ID_VALUE || cookie.get(HB_SESSION_ID_KEY)), _defineProperty(_objectSpread2, "start_time", Date.now()), _defineProperty(_objectSpread2, "nt", nt), _defineProperty(_objectSpread2, "net", net), _defineProperty(_objectSpread2, "nrtt", nrtt), _defineProperty(_objectSpread2, "ndlm", ndlm), _defineProperty(_objectSpread2, "ndl", ndl), _objectSpread2), rest);
  request(Config.VERB)("".concat(Config.TIME), perfData, callback);
  // 上报到 perf 大数据
  request(Config.VERB)("".concat(Config.PERF), _objectSpread(_objectSpread({}, perfData), {}, {
    only_big_data: true
  }), callback);
}, {});
var FMPCalculator = /*#__PURE__*/function () {
  // 当前观测的关键元素

  // 是否有路由切换

  // 是否已经上报

  // 观测开始事件

  function FMPCalculator(args) {
    _classCallCheck(this, FMPCalculator);
    _defineProperty(this, "currentObserverDom", null);
    _defineProperty(this, "routeChange", false);
    _defineProperty(this, "hasReport", false);
    _defineProperty(this, "observeBeginTime", (timing === null || timing === void 0 ? void 0 : timing.navigationStart) || (timing === null || timing === void 0 ? void 0 : timing.fetchStart) || Date.now());
    _defineProperty(this, "timerId", null);
    _defineProperty(this, "config", {
      container: document
    });
    this.config = _objectSpread(_objectSpread({}, this.config), args);
  }

  // 默认配置
  _createClass(FMPCalculator, [{
    key: "resetObserve",
    value:
    /**
     * 重置观测初始值
     *
     * @function resetObserve
     */
    function resetObserve() {
      // 切换路由，还没上报就取消上报吧
      this.cancelReport();
      this.hasReport = false;
      this.observeBeginTime = Date.now();
      if (this.currentObserverDom) {
        var _this$currentObserver, _this$currentObserver2;
        (_this$currentObserver = this.currentObserverDom) === null || _this$currentObserver === void 0 ? void 0 : (_this$currentObserver2 = _this$currentObserver.disconnect) === null || _this$currentObserver2 === void 0 ? void 0 : _this$currentObserver2.call(_this$currentObserver);
        this.currentObserverDom = null;
      }
      this.initObserve();
    }

    /**
     * 初始化观测，开始观测标记元素
     *
     * @function resetObserve
     * @return {Object} 返回当前 MutationObserver 对象
     */
  }, {
    key: "initObserve",
    value: function initObserve() {
      var _this = this;
      try {
        var _this$currentObserver4;
        this.currentObserverDom = new MutationObserver(function (mutationRecords) {
          var _iterator = _createForOfIteratorHelper(mutationRecords),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var record = _step.value;
              if (record && record.addedNodes) {
                var _iterator2 = _createForOfIteratorHelper(record.addedNodes),
                  _step2;
                try {
                  var _loop = function _loop() {
                    var node = _step2.value;
                    if (1 === node.nodeType && (node.hasAttribute(LOG_FLAG_N_FMP_HERO) || node.querySelector("[".concat(LOG_FLAG_N_FMP_HERO, "]")))) {
                      var _this$currentObserver3;
                      var timeByNoRaf = Date.now() - _this.observeBeginTime;
                      _this.timerId = rAF(function () {
                        var _objectSpread3;
                        var logFmpParams = node.getAttribute(LOG_FLAG_N_FMP_PARAMS);
                        var fmpParams = logFmpParams ? parse(logFmpParams) : {};
                        var time = Date.now() - _this.observeBeginTime;
                        var type = _this.routeChange ? 'rmp' : 'fmp';
                        var onReport = _this.config.onReport;
                        var perfData = _objectSpread(_objectSpread({}, fmpParams), {}, (_objectSpread3 = {
                          req_type: type,
                          elapsed: parseInt(String(time), 10)
                        }, _defineProperty(_objectSpread3, type, parseInt(String(time), 10)), _defineProperty(_objectSpread3, "time_by_no_raf", parseInt(String(timeByNoRaf), 10)), _objectSpread3));
                        var callback = function callback() {
                          return typeof onReport === 'function' && onReport(perfData);
                        };
                        if (!_this.hasReport) {
                          report(perfData, callback);
                          _this.hasReport = true;
                        }
                      });
                      (_this$currentObserver3 = _this.currentObserverDom) === null || _this$currentObserver3 === void 0 ? void 0 : _this$currentObserver3.disconnect();
                      return "break";
                    }
                  };
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var _ret = _loop();
                    if (_ret === "break") break;
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              if (_this.hasReport) {
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        (_this$currentObserver4 = this.currentObserverDom) === null || _this$currentObserver4 === void 0 ? void 0 : _this$currentObserver4.observe(this.config.container || document, {
          childList: true,
          subtree: true
        });
        return this.currentObserverDom;
      } catch (error) {
        console.error('not support MutationObserver');
      }
    }

    /**
     * 开始 fmp/rmp 观测
     *
     * @function resetObserve
     */
  }, {
    key: "startObserve",
    value: function startObserve() {
      var _this2 = this;
      this.teardown = onRouteChange(function (e) {
        var isTrusted = e.isTrusted,
          habo = e.habo;
        if (isTrusted || habo && !isTrusted) {
          _this2.routeChange = true;
          _this2.resetObserve();
        }
      });
      this.initObserve();
    }

    /**
     * 停止 fmp/rmp 观测
     *
     * @function resetObserve
     */
  }, {
    key: "stopObserve",
    value: function stopObserve() {
      this.cancelReport();
      if (typeof this.teardown === 'function') {
        this.teardown();
      }
    }

    /**
     * 切了后台，取消上报。
     *
     */
  }, {
    key: "cancelReport",
    value: function cancelReport() {
      var _this$currentObserver5;
      if (this.timerId) {
        cAF(this.timerId);
        this.timerId = null;
      }
      this.hasReport = true;
      (_this$currentObserver5 = this.currentObserverDom) === null || _this$currentObserver5 === void 0 ? void 0 : _this$currentObserver5.disconnect();
      this.currentObserverDom = null;
    }
  }], [{
    key: "getInstance",
    value:
    /**
     * 获取 FMPCalculator 实例
     *
     * @function getInstance
     * @param {?Object=} [ {container: document} ] 自定义配置值
     * @return {Object} fmpCalculator 实例
     */
    function getInstance(conf) {
      if (!FMPCalculator.instance) {
        FMPCalculator.instance = new FMPCalculator(_objectSpread({}, conf));
      }
      return FMPCalculator.instance;
    }
  }]);
  return FMPCalculator;
}();
var monitorFmp = function monitorFmp() {
  FMPCalculator.getInstance().cancelReport();
};

/**
 * 解除相关事件的绑定
*/
function destroy() {
  off(win, 'unload', destroy);
  FMPCalculator.getInstance().stopObserve();
  off(doc, visibilityChange, monitorFmp);
}
report.init = function () {
  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  FMPCalculator.getInstance(conf).startObserve();
  on(win, 'unload', destroy);
  on(doc, visibilityChange, monitorFmp);
};
export default report;